<template>
<div>
    <v-row>
      <v-col cols="1"></v-col>
      <v-col cols="8">
        <v-autocomplete
            v-model="key"
            :items="keys"
            clearable
            :loading="loading"
            :search-input.sync="search"
            hide-no-data
            no-filter
            @click:clear="keys = []"
            item-text="oem"
            :item-value="item => item"
            label="OEM/FCC/IC/iSKU"
            solo
            return-object
          >
          <v-list-tile name="ava1" class="pa-2" slot="item" slot-scope="{item}">
              <v-avatar left>
                  <v-img v-bind:src="item.image"></v-img>
              </v-avatar>
              {{item.oem}} - {{item.fcc}} - {{item.ic}}
          </v-list-tile>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-btn rounded large color="info" @click="add" >
            New Key
        </v-btn>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>

    <div v-show="key != null">
        <ViewKey :item="key"/>
    </div>

    <div>
        <router-view></router-view>
    </div>

  </div>

</template>

<script>
import ViewKey from './ViewKey.vue'

export default {
    components: {
        ViewKey
    },
    data: () => ({
        keys: [],
        key: null,
        loading: false,
        search: '',
    }),
    watch:{
      search(val){
        if(this.loading) return;
        if(val == '' || val == null) return;
        this.loading = true;
        this.$api.searchKey(val).then((response) => {
            if (response.status == 200)
                this.keys = response.data;
            this.loading = false;
        }).then(error => {
            this.loading = false;
        })
      }
    },
    methods: {
            add() {
                this.key = null;
                this.$router.push('/inventory/keys/new');
            },
            onClose() {
                this.key = null;
                this.keys = [];
            }


    }
}

</script>
